// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_n1-2";
export var interactiveWrapper = "_n1-0";
export var shippingHoverPreview = "_n1-4";
export var summaryBadgeTrigger = "_n1-1";
export var widgetHoverPreviewList = "_n1-3";
export var widgetPreviewScale = "_n1-5";